import { isInternal } from "@/access/permissions";
import { Icon } from "@/ui/Icon";
import { useConsole } from "./ConsoleContext";
import { useTheme } from "./theme";
import { useAssistant, useGlobalSearch, useProfilePanel } from "./panels";

export function Topbar({ onMenu }: { onMenu: () => void }) {
  const c = useConsole();
  const internal = isInternal(c.me);
  const { toggle } = useTheme();
  const search = useGlobalSearch();
  const assistant = useAssistant();
  const profile = useProfilePanel();
  const initials = c.me.name
    .split(" ")
    .filter(Boolean)
    .map((x) => x[0])
    .slice(0, 2)
    .join("");
  const canAllUnits = internal || c.me.units.includes("all");

  return (
    <header id="top">
      <div className="org">
        <button className="mobile icon-only" onClick={onMenu} aria-label="Menu">
          <Icon name="menu" />
        </button>
        <div className="orgmark">{internal ? "i" : (c.orgName(c.scope.org)[0] ?? "·")}</div>
        <div>
          <select title="Organização selecionada" aria-label="Organização" value={c.scope.org} onChange={(e) => c.setOrg(e.target.value)}>
            {internal && <option value="all">Todas as organizações</option>}
            {c.orgs.map((o) => (
              <option key={o.id} value={o.id}>
                {o.name}
              </option>
            ))}
          </select>
          <span className="muted">/</span>
          <select title="Unidade selecionada" aria-label="Unidade" value={c.scope.unit} onChange={(e) => c.setUnit(e.target.value)}>
            {canAllUnits && <option value="all">Todas as unidades</option>}
            {c.units.map((u) => (
              <option key={u.id} value={u.id}>
                {u.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="tools">
        {internal && (
          <select aria-label="Ambiente">
            <option>Produção</option>
            <option>Homologação</option>
            <option>Desenvolvimento</option>
          </select>
        )}
        <button className="optional" onClick={search} aria-label="Busca global">
          <Icon name="search" /> <span className="searchlabel">Buscar</span>
        </button>
        <button onClick={assistant} aria-label="Assistente" style={{ color: "var(--orange)" }}>
          <Icon name="sparkle" />
        </button>
        <button onClick={toggle} aria-label="Alternar tema">
          <Icon name="moon" />
        </button>
        <button onClick={profile} className="avatar" aria-label="Menu de perfil">
          {initials}
        </button>
      </div>
    </header>
  );
}
